import { Channel, UserResponse } from 'stream-chat';

const getPicturePath = (url: string): string => {
  if (url && url.includes('f=auto')) {
    return url.split(/f=auto,?/)[1];
  }
  return url;
};

export const getBuyerInfoFromChannel = (channel: Channel) => {
  const data = channel?.data;
  const createdBy = data?.created_by as UserResponse;
  return {
    username: createdBy?.username,
    picture: {
      path: getPicturePath(createdBy?.picture_path as string),
    },
    id: createdBy?.id,
    firstname: createdBy?.username,
  };
};

export const clientSideEncode = (str: string = '') => {
  if (typeof window !== 'undefined') {
    return window?.btoa(str);
  }
  return str;
};
